import { Route, Routes } from 'react-router-dom';
import VooksEventContent from '../components/VooksEventContent';

const EventPage = () => {
  return (
    <Routes>
      <Route path={'vooks/'} element={<VooksEventContent/>}></Route>
    </Routes>
  );
};

export default EventPage;
